// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__Xhv_h","vLegacy":"SelectSecondary_vLegacy__3EyXe","error":"SelectSecondary_error__3cmCP","disabled":"SelectSecondary_disabled__386_h"};